const reexamine = () => import('@/pages/reexamine/index.vue');
export default [
  {
    path: '/reexamine',
    name: 'reexamine',
    component: reexamine,
  },
];
